import React, { useContext } from "react";
import { makeGet } from "@culturehq/client";

import { usePagedEntity } from "app/hooks";

import * as CHQ from "chq";

type CompaniesState = {
  allCompaniesFetched: boolean;
  onAllCompaniesRequested: () => void;
  onAutocompleteCompanies: (_query: string) => void;
  onNextCompanyPageRequested: () => void;
  onCompaniesRequested: (_companyIds: number[]) => void;
  companies: { [key: number]: CHQ.Company };
};

const CompanyContext = React.createContext<CompaniesState>({
  allCompaniesFetched: false,
  onAllCompaniesRequested: () => {},
  onAutocompleteCompanies: () => {},
  onNextCompanyPageRequested: () => {},
  onCompaniesRequested: () => {},
  companies: {}
});

const onFetchPage = (page: number) => makeGet("/companies", { page });
const onFetchEntity = (companyId: number) => makeGet(`/companies/${companyId}`);
const onFetchAutocomplete = (query: string) => makeGet("/autocomplete/companies", { query });

export const CompanyProvider: React.FC = ({ children }) => {
  const value = usePagedEntity("companie", onFetchPage, onFetchEntity, onFetchAutocomplete);

  return (
    <CompanyContext.Provider value={value as CompaniesState}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompanies = () => useContext(CompanyContext);
